(function($, undefined) {
	
	'use strict';
	var formValidator;
	var tools;
	var stripe;
	var worldPay;
	var checkoutContinueBtn;
	var checkoutBackBtn;
	var checkoutConfirmBtn;
    var checkoutParams;

	var continueCheckout = function(t) {
		var btn;
		if (t.length) {
			btn = t;
		} else {
			btn = $(this);
		}
		var form = btn.closest('form');
		var personRecap = $('.checkout-recap-infos-ctn.person .checkout-recap-infos-inner');
		var cardRecap = $('.checkout-recap-infos-ctn.card .checkout-recap-infos-inner');
		var stepOne = $('.checkout-step.one');
		var stepTwo = $('.checkout-step.two');

		tools.ignoreUnusedStates(form);
		formValidator.validateForm(form);
		
		if (!form.hasClass('has-error')) {
            checkoutParams = [];
            stepOne.find('.form-input').each(function() {
                if ($(this).hasClass('select-state-input')) {
                    if ($(this).hasClass('selected')) {
                        checkoutParams.push({
                            name: this.name,
                            value: this.value
                        });
                    }
                } else {
                    checkoutParams.push({
                        name: this.name,
                        value: this.value
                    });
                }
            });
            
			var firstName = stepOne.find('input[name=firstName]').val();
			var lastName = stepOne.find('input[name=lastName]').val();
			var email = stepOne.find('input[name=email]').val();
			var companyName = stepOne.find('input[name=companyName]').val();
            var field4 = stepOne.find('input[name=field4]').val();
            var field5 = stepOne.find('input[name=field5]').val();
            var field6 = stepOne.find('input[name=field6]').val();
			var street = stepOne.find('input[name=street]').val();
			var street2 = stepOne.find('input[name=street2]').val();
			var city = stepOne.find('input[name=city]').val();
			var province = form.find('.select-state-input-ctn.selected select').val();
			var postalCode = stepOne.find('input[name=postalCode]').val();
			var country = form.find('.select-country-input option:selected').html();
            var arrayCPP = [];

			if (street2 !== '') {
				street = street2 + ' - ' + street;
			}
            if (city !== '') {
                arrayCPP.push(city);
            }
            if (province !== '') {
                arrayCPP.push(province);
            }
            if (postalCode !== '') {
                arrayCPP.push(postalCode);
            }

            personRecap.empty();
			personRecap.append('<p>' + firstName + ' ' + lastName + '</p>');
			personRecap.append('<p>' + email + '</p>');
			personRecap.append('<p>' + companyName + '</p>');
            if (field4) personRecap.append('<p>' + field4 + '</p>');
            if (field5) personRecap.append('<p>' + field5 + '</p>');
            if (field6) personRecap.append('<p>' + field6 + '</p>');
			personRecap.append('<p>' + street + '</p>');
			if (arrayCPP.length) personRecap.append('<p>' + arrayCPP.join(', ') + '</p>');
			personRecap.append('<p>' + country + '</p>');
            
            var surveyCtn = $('.form-survey-ctn');
            if (surveyCtn[0]) {
                var str = '';
                surveyCtn.find('.form-survey-question').each(function() {
                    var it = $(this);
                    var toggledCtn = it.parents('.element-to-toggle');
                    
                    if (!toggledCtn.length || toggledCtn.css('display') !== 'none') {
                        if (str !== '') str += '\n';
                        str += it.text() + ' ';
                        str += it.next('.form-survey-answer-check').find('.form-check-input:checked').val();
                    }
                });
                surveyCtn.find('.form-survey-text-input').each(function() {
                    var it = $(this);
                    var toggledCtn = it.parents('.element-to-toggle');
                    
                    if (!toggledCtn.length || toggledCtn.css('display') !== 'none') {
                        if (str !== '') str += '\n';
                        str += it.find('.form-input-label').text() + ' ';
                        str += it.find('.form-input').val();
                    }
                });
                surveyCtn.find('.form-survey-main-input').val(str);
            }
			
            var paymentChoiceInp = $('.card-inputs-payment-choice [name="payment-type-toggle"]:checked');
            
            if (!$('.checkout-pmihu-agreement-input', form)[0]) {
                cardRecap.empty();
                var cardCtn = form.find('.card-inputs-inner');
                if (!cardCtn.hasClass('hide')) {
                    var paymentChoiceText = paymentChoiceInp.closest('label').find('.payment-choice').html();
                    if (paymentChoiceText && paymentChoiceText !== '') {
                        cardRecap.append('<p>' + paymentChoiceText + '</p>');
                    }
                    var paymentType = form.find('.checkout-payment-inputs input[name="paymentType"]').val();
                    var cheque = form.find('.checkout-payment-inputs input[name="cheque"]').val();
                    if (paymentType === 'card' || cheque === 'false') {
                        var cc = cardCtn.find('input[name="ccCard"]').val();
                        if (cc) {
                            cardRecap.append('<p>************' + cc.substring(cc.length - 4, cc.length) + '</p>');
                            cardRecap.append('<p>' + cardCtn.find('[name="expMM"]').val() + '/' + cardCtn.find('[name="expYY"]').val() + '</p>');
                        } else {
                            cardRecap.empty();
                        }
                    } else {
                        //cardCtn.find('.form-input').val(''); To be tested
                    }
                }
            }
            
            //Smart Paypal Button + Cheque
            if ($('.checkout-paypal-ctn, .checkout-cheque-ctn').length > 1) {
                if (paymentChoiceInp.val() === 'cheque') {
                    $('.checkout-paypal-ctn').hide();
                    $('.checkout-cheque-ctn').show();
                    $('.checkout-step-btns.two .us-paypal-notice').hide();
                } else {
                    $('.checkout-paypal-ctn').show();
                    $('.checkout-cheque-ctn').hide();
                    $('.checkout-step-btns.two .us-paypal-notice').show();
                }
            }
            
            // Netherlands iDEAL issuer select
            var issuersCtn = form.find('.checkout-ideal-issuers');
            if (issuersCtn.length) {
                var issuerSelect = issuersCtn.find('.form-select');
                if (form.find('.checkout-ideal-selector').prop('checked')) {
                    issuersCtn.removeClass('hide');
                    issuerSelect.removeClass('required');
                    // Fetch issuer list
                    
                } else {
                    issuersCtn.addClass('hide');
                    issuerSelect.removeClass('required');
                }
            }

			$('.card-inputs').fadeOut();
			$('.step-text.1').fadeOut(function() {
				$('.step-text.2').fadeIn();
			});
			$('.checkout-step-btns.one').fadeOut(function() {
				$('.checkout-step-btns.two').fadeIn();
			});

			$('.checkout-one-step-number-ctn.1').removeClass('active').addClass('done');
			setTimeout(function() {
				$('.checkout-one-step-number-ctn.2').addClass('active');
			}, 300);

			stepOne.slideUp(function() {
				stepTwo.slideDown();
				$('html').animate({scrollTop: stepTwo.offset().top - 20}, 300);
				$('body').animate({scrollTop: stepTwo.offset().top - 20}, 300);
			});
		}
	};

	var backCheckout = function() {
		$('.step-text.2').fadeOut(function() {
			$('.step-text.1').fadeIn();
		});
		$('.checkout-step.two').slideUp(function() {
			$('.checkout-step.one').slideDown();
		});

		$('.checkout-step-btns.two').fadeOut(function() {
			$('.checkout-step-btns.one').fadeIn();
			$('.card-inputs').fadeIn();
            // Reset Netherlands iDEAL issuer select
            $('.checkout-ideal-issuers').addClass('hide')
                    .find('.form-select').removeClass('required');
		});

		$('.checkout-one-step-number-ctn.1').removeClass('done').addClass('active');
		$('.checkout-one-step-number-ctn.2').removeClass('active');
	};
    
    var submitCheckout = function() {
        $(this).addClass('disabled').closest('form').submit();
    };
    
    var renderPaypalButton = function() {
        var el = document.getElementById('checkoutPaypalButton');
        if (!el || typeof paypal === undefined) {
            return;
        }
        
        if (window.navigator.userAgent.match(/(MSIE|Trident)/)) {
            $('.checkout-browser-unsupported-warning').removeClass('hide');
        }
        
        $.ajax({
            url: "/action/pmiPayPalOrder?render=true",
            method: "GET",
            type: "GET",
            dataType: "text",
            success: function(response) {
                var json = JSON.parse(response.trim().replace(/(\0|\\u0000)/g, ""));
                // JSONArray
                for (var i = 0; i < json.length; i++) {
                    var jo = json[i];
                    // Cart items
                    for (var item in jo.items) {
                        var descr = jo.items[item].description;
                        var name = jo.items[item].name;
                        // The purchase description. Maximum length: 127.
                        if (descr !== undefined && descr.length > 127) {
                            var i1, i2;
                            descr = descr.substring(0, 127);
                            i1 = descr.lastIndexOf("&");
                            i2 = descr.lastIndexOf(";");
                            // In case where there is a unicoded character (&#224;)
                            // that is cut at the end of the string, we trim it 
                            // down until before the "&" character.
                            if (i1 > 0 && (i1 > i2 || i2 === -1)) {
                                descr = descr.substring(0, i1 - 1);
                            }
                            // Set the description with the new value
                            jo.items[item].description = descr;
                        }
                        // The purchase name. Maximum length: 120.
                        if (name !== undefined && name.length > 120) {
                            var i1, i2;
                            name = name.substring(0, 120);
                            i1 = name.lastIndexOf("&");
                            i2 = name.lastIndexOf(";");
                            // In case where there is a unicoded character (&#224;)
                            // that is cut at the end of the string, we trim it 
                            // down until before the "&" character.
                            if (i1 > 0 && (i1 > i2 || i2 === -1)) {
                                name = name.substring(0, i1 - 1);
                            }
                            // Set the name with the new value
                            jo.items[item].name = name;
                        }
                    }
                }
                Object.freeze(json);
                
                // Render PayPal
                /* https://developer.paypal.com/docs/checkout/integrate/ */
                /* https://developer.paypal.com/docs/checkout/integration-features/customize-button/ */
                paypal.Buttons({
                    style: {
                        layout: 'horizontal'
                    },
                    // Before opening the paypal popup
                    createOrder: function (data, actions) {
                        var elems = $('.checkout-form')[0].elements;
                        var payer = {};
                        var phoneNumber = elems.phone && elems.phone.value ? elems.phone.value.replace(/[_\-\+\.\s]/g, '') : '';
                        
                        if (/^[0-9]{1,14}?$/.test(phoneNumber)) {
                            payer.phone = {
                                phone_type: 'MOBILE',
                                phone_number: {
                                    national_number: phoneNumber
                                }
                            };
                        }
                        payer.name = {
                            given_name: elems.firstName.value,
                            surname: elems.lastName.value
                        };
                        payer.email_address = elems.email.value;
                        payer.address = {
                            address_line_1: elems.street.value,
                            address_line_2: elems.street2.value,
                            admin_area_1: $('.checkout-form .select-state-input.selected').val(),
                            admin_area_2: elems.city.value,
                            postal_code: elems.postalCode.value,
                            country_code: elems.country.value
                        };
                        
                        return actions.order.create({
                            intent: 'CAPTURE',
                            purchase_units: json,
                            payer: payer,
                            application_context: {
                                shipping_preference: 'NO_SHIPPING'
                            }
                        });
                    },
                    // After the user clicks on Pay and the paypal closes
                    onApprove: function (data, actions) {
                        $('.popup-outer[data-id="checkout_processing_wait"]').addClass('open');
                        
                        var q = '?orderID=' + data.orderID + "&payerID=" + data.payerID;
                        for (var i = 0; i < checkoutParams.length; i++) {
                            var p = checkoutParams[i];
                            q += '&' + p.name + '=' + encodeURIComponent(p.value);
                        }
                        if ($("input[name='sendInvoicePerSignup']").prop('checked')) {
                            q += '&sendInvoicePerSignup=true';
                        }
                        
                        return window.fetch('/action/pmiPayPalOrder' + q, {
                            method: 'post',
                            headers: {
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify({
                                orderID: data.orderID
                            })
                        }).then(function (_response) {
                            return _response.json(); //Promise
                        }).then(function (_details) {
                            console.log(_details.result);
                            window.location.search = 'success';
                        }).catch(function (_reject) {
                            console.error(_reject);
                            window.location.search = 'ccError';
                        });
                    },
                    // Handles any errors
                    onError: function (err) {
                        console.error(err);
                        $('.popup-outer[data-id="checkout_processing_wait"]').removeClass('open');
                        popErrorSite('errorMessageAjaxSite');
                        document.getElementById('errorMessageAjaxSite').innerHTML =
                            "<div>An error occurred during the process. Please try again or contact us if the problem persists.</div>";
                    }
                }).render('#checkoutPaypalButton');
            }
        });
    };
    
    var removeCheckRequired = function(e) {
        var ctn = $(this).closest('.form-survey-answer-check');
        ctn.find('.form-check-input.required').addClass('derequired').removeClass('required');
        ctn.find('.radio-btn').removeClass('error');
    };
    
    var huRequireField4 = function(e) {
        if (this.value) {
            $('.checkout-form .form-input[name=field4]').addClass('required').trigger('blur');
        } else {
            $('.checkout-form .form-input[name=field4]').removeClass('required').trigger('blur');
        }
    };
    
    var huToggleConfirmButton = function(e) {
        var confirmBtn = $(this).closest('.checkout-step-btns').find('.validate-form-btn');
        if (!$('.checkout-pmihu-agreement-input:not(:checked)').length) {
            confirmBtn.removeClass('hide disabled'). removeAttr('disabled');
        } else {
            confirmBtn.addClass('disabled'). attr('disabled', '');
        }
    };

	var init = function () {
		formValidator = Fw.component.models().form;
		tools = Fw.component.models().tools;

		checkoutContinueBtn = $('.checkout-continue-btn');
		checkoutBackBtn = $('.checkout-back-btn');
		checkoutConfirmBtn = $('.checkout-confirm-btn');
        
		if ($('#stripe-cc-form').length) {
			stripe = Fw.component.models().stripeToken;      
			stripe.init();
		} else if ($('#worldpay-cc-form').length) {
			worldPay = Fw.component.models().worldpayToken;
			worldPay.init();
		} else {
			checkoutContinueBtn.click(continueCheckout);
		}

        if ($('#stripe-cc-form2').length) {
			stripe = Fw.component.models().stripeIntent;      
			stripe.init();
		}

		checkoutBackBtn.click(backCheckout);
		checkoutConfirmBtn.click(submitCheckout);
        
        $('.form-survey-answer-check .form-check-input.required').on('change', removeCheckRequired);
        
        // Paypal integration
        renderPaypalButton();
        
        if (getQuery('skip') === '1') {
            checkoutContinueBtn.trigger('click');
        }
        
        // PMI Budapest
        if ($('.checkout-pmihu-agreement-input')[0]) {
            // Tax ID (extra field4) required if Company Name is filled
            $('.checkout-form .form-input[name=companyName]').on('change keypress', huRequireField4)
                .trigger('change');
            // Toggle display Confirm button from the acceptance checkboxes
            $('.checkout-pmihu-agreement-input').on('change', huToggleConfirmButton);
        }

        // **Delivery Address Checkbox Handling**
        var deliveryCheckbox = $('#deliveryAddressCheckbox');
        var deliverySection = $('#delivery-address-section');
        var deliveryStreet1 = $('.deliveryStreet1');
        var deliveryCity = $('.deliveryCity');
        var deliveryPostalCode = $('.deliveryPostalCode');
        var deliveryCountry = $('.deliveryCountry');



        // Toggle visibility when checkbox is clicked
        deliveryCheckbox.on('change', function () {
            if ($(this).is(':checked')) {
                //deliverySection.slideDown();
                deliverySection.show();
                deliveryStreet1.addClass('required');
                deliveryCity.addClass('required');
                deliveryPostalCode.addClass('required');
                deliveryCountry.addClass('required');
            } else {
                //deliverySection.slideUp();
                deliverySection.hide();
                deliveryStreet1.removeClass('required');
                deliveryCity.removeClass('required');
                deliveryPostalCode.removeClass('required');
                deliveryCountry.removeClass('required');
            }
        });
	};

	$(window).ready(init);
    
    Fw.component.export('checkout', {
		continueCheckout: continueCheckout
	});
	
})(jQuery);
